module.exports = {"411322001":"凤瑞街道","411322002":"释之街道","411322101":"独树镇","411322102":"博望镇","411322103":"拐河镇","411322104":"小史店镇","411322105":"赵河镇","411322106":"广阳镇","411322107":"二郎庙镇","411322108":"杨楼镇","411322109":"券桥镇","411322110":"清河镇","411322111":"四里店镇","411322112":"古庄店镇","411322113":"杨集镇","411322114":"柳河镇","411322311":"袁店回族乡","411322400":"河南中南机械厂","411322401":"方城大寺林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411322.json
// module id = 1641
// module chunks = 0